import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetTasksStatsParams = {
  filters: {
    employee?: string[];
  };
};

type UseGetTasksStatsProps = {
  params: UseGetTasksStatsParams;
  enabled?: boolean;
};

interface TasksStatsResponse {
  task_overdue: number;
  task_due_today: number;
}

const fetchDashboardTasksStats = async ({ params }: UseGetTasksStatsProps) => {
  const response = await CustomAxios.get<TasksStatsResponse>(`dashboard/tasks-stats`, { params });
  const { data } = response;
  return data;
};

export function useGetDashboardTasksStats({ params, enabled = true }: UseGetTasksStatsProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.dashboardTasks, params],
    queryFn: () => fetchDashboardTasksStats({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
